// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/layers.js';

import { paths } from '../generated/layers';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('layers', Original, paths);
